import './modal.css';
import React, { useMemo } from 'react';
import { iconClose } from '../util/icons';

export interface ModalProps {
  children: React.ReactNode;
  title?: string;
  footer?: React.ReactNode;
  close(): void;
}

export const Modal = (props: ModalProps) => {

  const footer = useMemo(() =>
    props.footer && <div className="modal-footer">
      {props.footer}
    </div>
    , [props.footer]);

  return (
    <div className="modal-background">
      <div className="modal-forground">
        <div className="modal-container">
          <div className="modal-top-div">
            <div className="modal-title">{props.title}</div>
            <div className="modal-options">
              <button onClick={props.close} className="modal-close-button">{iconClose}</button>
            </div>
          </div>
          <div className="modal-content">
            {props.children}
          </div>
          {footer}
        </div>
      </div>
    </div>
  );
}
